import { useMemo } from "react";

import { SelectableStateType, TrackerData } from "./types";
import { getTrackerState } from "./state_calc";

export const sanitizeFileNamePart = (part: string) => {
  return part.replace(/[^a-zA-Z0-0\-]/g, '');
};

export const useSortTrackers = (trackers: TrackerData[] | undefined) => {
  return useMemo(() => {
    if(trackers == null) {
      return undefined;
    }

    return Array.from(trackers.values()).sort((dataA, dataB) => {
      const nameA = typeof dataA.id === 'string' ? dataA.id : '';
      const nameB = typeof dataB.id === 'string' ? dataB.id : '';

      return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
    });
  }, [trackers]);
}

export const useStateFilter = (entries: TrackerData[] | undefined, state: SelectableStateType | undefined) => {
  return useMemo(() => {
    if(entries == null) {
      return undefined;
    }

    if(state == null || state === 'all') {
      return entries;
    }

    return entries.filter((data) => {
      return getTrackerState(data) === state;
    });
  }, [entries, state]);
}

export const useSearchFilter = (entries: TrackerData[] | undefined, filter: string | undefined) => {
  return useMemo(() => {
    if(entries == null) {
      return undefined;
    }

    if(filter == null || filter === '') {
      return entries;
    }

    const lowerFilter = filter.toLowerCase();

    return entries.filter((data) => {
      for(const key of ['id', 'name', 'controller']) {
        const value = data[key];

        if(typeof value === 'string' && value.toLowerCase().indexOf(lowerFilter) >= 0) {
          return true;
        }
      }

      return false;
    });
  }, [entries, filter]);
}

